module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "id": "ch9",
      "title": "Why Do People Have Eyebrows?"
    }
  }, [_c('p', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#rch9"
    }
  }, [_vm._v("Why Do People Have Eyebrows?")])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "193",
      "src": "images/f012.jpg",
      "width": "193"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("As humans evolved, we lost most of the thick hair that once covered our bodies. But why did we keep that little bit over the eyes, and what purpose does it serve? It might amaze you to discover that those innocent strips of hair could well be the reason we are here today.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eyebrows assisted greatly in the survival of early man. Apart from deflecting debris and shielding the eyes from the sun, they keep moisture from rain or sweat out of our eyes. The arch shape diverts the moisture to the side of the face, keeping the eyes dry so that our vision remains clear. This would have helped our ancestors find shelter in the rain, and it would have helped them escape predators. Running from an attack would likely produce sweat, and if sweat got in the eyes, it would have caused irritation, impaired vision, and made it more difficult to escape. Given this survival advantage, natural selection would have picked those who had eyebrows.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_vm._v("Some scientists also suggest that eyebrows, combined with eyelashes, served as eyespots, creating the illusion that a person’s eyes were open even when they were asleep. Nighttime predators such as big cats are far less likely to attack prey if they think the prey is watching them. This also would have provided a distinct survival advantage to our ancestors.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another reason eyebrows were retained is that they play a significant psychological role. They are one of our most expressive facial features and are essential for nonverbal communication. The different positions and movements of eyebrows are key to signaling change in mood, such as expressing surprise, happiness, and anger. This was important from an evolutionary perspective, as early man’s survival hinged on strong-functioning and close-knit tribes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eyebrows are also a very distinctive aspect of human appearance and act as identification cards. They stand out from the forehead and can be clearly seen from a distance. This would have been helpful for early man in distinguishing between friend and enemy on the open plains. In fact, experiments have shown that we can recognize a familiar face more easily when the eyes are blanked out than when the eyebrows are. This was shown in a 2002 study published by students at the Massachusetts Institute of Technology. In 60 percent of all trials, people were able to successfully recognize photos of celebrities with their eyes edited out, compared with a 46 percent success rate when the eyebrows were removed.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7318de8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Chapter009.vue
// module id = 96
// module chunks = 0